import { get } from './index';
import qs from 'qs';

export const getCities = ({ filters }) => {
  const queryString = qs.stringify(filters);

  return get(`/cities?${queryString}`);
};
